import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import PopoverButton from '../../common/controls/popoverButton';
import entityComposition from '../../common/classes/entityComposition';
import { valueSelector } from '../selectors';
const AddFromOptionsButton = ({
  enabled,
  groupedOptions: _groupedOptions = [],
  optionsExclusionKey: _optionsExclusionKey = '',
  testingIdentifier: _testingIdentifier = 'missing',
  title,
  value: _value = null,
  onAdd
}) => {
  const [open, setOpen] = useState(false);
  const filteredGroupOptions = useMemo(() => {
    const updatedOptions = [];
    const valuesToExclude = _value ? Object.keys(_value).map(key => _value[key][_optionsExclusionKey]) : [];
    _groupedOptions.forEach(go => {
      if (go.label) {
        updatedOptions.push({
          groupLabel: go.label
        });
      }
      // each group has children
      go.children.forEach(c => {
        if (!valuesToExclude.includes(c[_optionsExclusionKey])) {
          updatedOptions.push({
            id: c[_optionsExclusionKey],
            name: c.title
          });
        }
      });
    });
    return updatedOptions;
  }, [_groupedOptions, _optionsExclusionKey, _value]);
  const handleToggle = () => setOpen(!open);
  const handleAdd = item => {
    const itemToAdd = {
      title: item.name,
      identifier: item.id
    };
    onAdd(null, itemToAdd);
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(PopoverButton, {
    enabled: enabled,
    header: false,
    isOpen: open,
    list: filteredGroupOptions,
    onSelect: handleAdd,
    onToggle: handleToggle,
    title: title,
    testingIdentifier: _testingIdentifier,
    className: "btn-block tqc-control"
  });
};
AddFromOptionsButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  groupedOptions: PropTypes.arrayOf(PropTypes.shape({})),
  onAdd: PropTypes.func.isRequired,
  optionsExclusionKey: PropTypes.string,
  testingIdentifier: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.shape({})
};
export { AddFromOptionsButton as UncomposedAddFromOptionsButton };
export default entityComposition(AddFromOptionsButton, [], {
  value: valueSelector
});